module.exports = __webpack_public_path__ + "img/model.7325a22a.png";